// AUTO-GENERATED FILE. Do not edit.
export const APP_VERSION = '1.4.0';
